/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());
export { Application };
//# sourceMappingURL=Application.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/Context/Application.js
// module id = 370
// module chunks = 0